import I18n from "i18n-js";
import React from "react";

export default class CourseCard extends React.Component {
  constructor(props) {
    super(props);

    this.modalRef = React.createRef();

    this.state = {
      course_added: this.props.course_added || false,
    };

    this.addToMyCourses = this.addToMyCourses.bind(this);
    this.confirmRemoveFromMyCourses =
      this.confirmRemoveFromMyCourses.bind(this);
    this.onGotoCourse = this.onGotoCourse.bind(this);
    this.onGotoLearningPlanCourse = this.onGotoLearningPlanCourse.bind(this);
    this.removeFromMyCourses = this.removeFromMyCourses.bind(this);
    this.onKeyDownRemove = this.onKeyDownRemove.bind(this);
  }

  render() {
    if (this.props.search_display == "list") {
      return (
        <div
          className={
            "course-card course-card-list " +
            "course-" +
            this.props.course_public_id +
            " " +
            (this.props.course_progress > 0 ? "in-progress " : " ") +
            (this.props.number ? "has-number " : " ") +
            (this.props.user_id ? " " : "no-add-remove ")
          }
        >
          <a
            href={
              this.state.course_added
                ? this.props.path
                : this.props.preview_path
            }
            role={
              this.props.course_preview == "preview_modal" ? "button" : "link"
            }
            className="image"
            onClick={this.onGotoCourse}
          >
            <img
              src={this.props.image_src}
              alt={"Image of " + this.props.name}
            />
            {this.props.number ? (
              <span className="number">{this.props.number}</span>
            ) : null}
          </a>

          <div className="details">
            <a
              href={
                this.state.course_added
                  ? this.props.path
                  : this.props.preview_path
              }
              role={
                this.props.course_preview == "preview_modal" ? "button" : "link"
              }
              className="name course-card-name"
              onClick={this.onGotoCourse}
            >
              {this.props.name}
            </a>
            {this.props.course_collection ? (
              <div className="course-collection">
                {this.props.course_collection.name}
              </div>
            ) : null}
            {this.props.knowledge_level ? (
              <span className={"label label-" + this.props.knowledge_level}>
                {this.props.knowledge_level}
              </span>
            ) : null}
            {this.renderAddRemove()}
          </div>

          {this.renderPreviewModal()}

          <div className="clearfix" />
        </div>
      );
    } else if (this.props.learning_plan_mode) {
      return (
        <div
          className={
            "course-card course-card-sortable " +
            "course-" +
            this.props.course_public_id +
            " " +
            (this.props.course_progress <= 0 ? "ready-to-get-started " : " ") +
            (this.props.number ? "has-number" : "")
          }
          data-id={this.props.course_id}
        >
          <a
            href={this.props.path}
            onClick={this.onGotoLearningPlanCourse}
            className="image"
          >
            <img
              src={this.props.image_src}
              alt={"Image of " + this.props.name}
            />
            {this.props.number ? (
              <span className="number">{this.props.number}</span>
            ) : null}
          </a>
          <a
            href={this.props.path}
            className="name course-card-name"
            onClick={this.onGotoLearningPlanCourse}
          >
            {this.props.name}
          </a>
          {this.renderProgressSection()}
          {this.renderPreviewModal()}
        </div>
      );
    } else if (this.props.sortable) {
      return (
        <div
          className={
            "course-card course-card-sortable " +
            "course-" +
            this.props.course_public_id +
            " " +
            (this.props.course_progress <= 0 ? "ready-to-get-started " : " ") +
            (this.props.number ? "has-number" : "")
          }
          data-id={this.props.course_id}
        >
          <a
            href={
              this.state.course_added
                ? this.props.path
                : this.props.preview_path
            }
            role={
              this.props.course_preview == "preview_modal" ? "button" : "link"
            }
            onClick={this.onGotoCourse}
            className="image"
          >
            <img
              src={this.props.image_src}
              alt={"Image of " + this.props.name}
            />
            {this.props.number ? (
              <span className="number">{this.props.number}</span>
            ) : null}
          </a>
          <a
            href={
              this.state.course_added
                ? this.props.path
                : this.props.preview_path
            }
            role={
              this.props.course_preview == "preview_modal" ? "button" : "link"
            }
            className="name course-card-name"
            onClick={this.onGotoCourse}
          >
            {this.props.name}
          </a>
          {this.renderProgressSection()}
          <span
            className="fa fa-bars"
            aria-label={I18n.t("sort_course_name", { name: this.props.name })}
          >
            &nbsp;
          </span>
          <span
            className="fa fa-close"
            onClick={this.props.onRemove}
            onKeyDown={this.onKeyDownRemove}
            tabIndex="0"
            role="button"
            data-id={this.props.course_id}
            aria-label={I18n.t("remove_course_name_from_my_courses", {
              name: this.props.name,
            })}
          >
            &nbsp;
          </span>
          {this.renderPreviewModal()}
        </div>
      );
    } else {
      return (
        <div
          className={
            "course-card " +
            "course-" +
            this.props.course_public_id +
            " " +
            (this.props.course_progress > 0 ? "in-progress " : " ") +
            (this.props.number ? "has-number " : " ") +
            (this.props.user_id ? " " : "no-add-remove ")
          }
        >
          <a
            href={
              this.state.course_added
                ? this.props.path
                : this.props.preview_path
            }
            role={
              this.props.course_preview == "preview_modal" ? "button" : "link"
            }
            className="name course-card-name"
            onClick={this.onGotoCourse}
          >
            {this.props.name}
          </a>
          <a
            href={
              this.state.course_added
                ? this.props.path
                : this.props.preview_path
            }
            role={
              this.props.course_preview == "preview_modal" ? "button" : "link"
            }
            className="image"
            onClick={this.onGotoCourse}
          >
            <img
              src={this.props.image_src}
              alt={"Image of " + this.props.name}
            />
            {this.props.number ? (
              <span className="number">{this.props.number}</span>
            ) : null}
          </a>
          {this.renderAddRemove()}
          {this.renderPreviewModal()}
        </div>
      );
    }
  }

  renderPreviewModal() {
    return (
      <div
        className="modal fade"
        tabIndex="-1"
        role="dialog"
        ref={this.modalRef}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  $(this.modalRef.current).modal("hide");
                }}
              >
                <span className="fa fa-close">&nbsp;</span>
              </button>
              <h2 className="modal-title text-left">{this.props.name}</h2>
            </div>
            <div className="modal-body text-left" role="document">
              <div className="row">
                <div className="col-sm-4">
                  <div
                    className="image"
                    style={{
                      cursor: "default",
                      background: "#EFEFEF",
                      top: -5,
                      left: 5,
                    }}
                  >
                    <img
                      src={this.props.image_src}
                      alt={"Image of " + this.props.name}
                    />
                    {this.props.number ? (
                      <span className="number">{this.props.number}</span>
                    ) : null}
                  </div>
                </div>
                <div className="col-sm-8">
                  <h4
                    style={{
                      fontSize: "18px",
                      lineHeight: "26px",
                      marginTop: 0,
                      marginBottom: 0,
                    }}
                  >
                    {this.props.abstract}
                  </h4>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <a href={this.props.path} className="btn btn-primary">
                Start now
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderAddRemove() {
    if (this.props.user_id) {
      if (this.state.course_added) {
        return (
          <a
            href="#"
            onClick={this.removeFromMyCourses}
            className="remove-from-my-courses"
            aria-label={I18n.t("course_name_added_click_to_remove", {
              name: this.props.name,
            })}
          >
            Added (click to remove)
          </a>
        );
      } else {
        return (
          <a
            href="#"
            onClick={this.addToMyCourses}
            className="add-to-my-courses"
            aria-label={I18n.t("course_name_add_to_my_courses", {
              name: this.props.name,
            })}
          >
            {I18n.t("add_to_my_courses")}
          </a>
        );
      }
    }
  }

  renderProgressSection() {
    if (this.props.learning_plan_mode) {
      return this.renderLearningPlanProgress();
    } else {
      if (this.props.course_progress > 0) {
        return (
          <div className="progress-section">
            <div className="course-progress">
              <div
                className="progress-bar-chart"
                role="progressbar"
                aria-label={I18n.t("course_name_progress_bar", {
                  name: this.props.name,
                })}
                aria-valuemin="0"
                aria-valuemax="100"
                aria-valuenow={this.progressPercentage()}
              >
                <div
                  className="progress-amount"
                  style={{ width: this.progressPercentage() + "%" }}
                />
              </div>
              <div className="progress-percentage" role="presentation">
                {this.progressPercentage()}% <span>PROGRESS</span>
              </div>
              {this.renderQuizScore()}
            </div>
            <div className="clearfix">&nbsp;</div>
          </div>
        );
      } else {
        return (
          <div className="progress-section ready-to-get-started">
            <em>Ready to get started?</em>
            <div className="pull-right start-button">
              <a
                href={
                  this.state.course_added
                    ? this.props.path
                    : this.props.preview_path
                }
                aria-label={I18n.t("start_course_name", {
                  name: this.props.name,
                })}
                className="btn btn-primary"
              >
                {I18n.t("start")}
              </a>
            </div>
          </div>
        );
      }
    }
  }

  renderLearningPlanProgress() {
    if (!this.props.preTestCompleted) {
      return (
        <div className="progress-section ready-to-get-started">
          <div className="pull-right start-button">
            <a
              href={this.props.preTestUrl}
              className="btn btn-primary modal-link hide-modal-footer"
            >
              Start
            </a>
          </div>
        </div>
      );
    } else if (this.props.preTestCompleted && this.props.course_progress == 0) {
      return (
        <div className="progress-section">
          <div className="course-progress">
            <div className="progress-bar-chart">
              <div
                className="progress-amount"
                style={{ width: this.progressPercentage() + "%" }}
              />
            </div>
            <div className="progress-percentage">
              {this.progressPercentage()}% <span>PROGRESS</span>
            </div>
            <div className="test-score">
              <div className="pull-right start-button">
                <a href={this.props.path} className="btn btn-primary">
                  Teach me
                </a>
              </div>
            </div>
          </div>
          <div className="clearfix">&nbsp;</div>
        </div>
      );
    } else if (
      this.props.preTestCompleted &&
      !this.props.postTestPassed &&
      this.props.course_progress > 0 &&
      this.props.course_progress < 1
    ) {
      return (
        <div className="progress-section">
          <div className="course-progress">
            <div
              className="progress-bar-chart"
              role="progressbar"
              aria-label={I18n.t("course_name_progress_bar", {
                name: this.props.name,
              })}
              aria-valuemin="0"
              aria-valuemax="100"
              aria-valuenow={this.progressPercentage()}
            >
              <div
                className="progress-amount"
                style={{ width: this.progressPercentage() + "%" }}
              />
            </div>
            <div className="progress-percentage" role="presentation">
              {this.progressPercentage()}% <span>PROGRESS</span>
            </div>
            <div className="test-score">
              <div className="pull-right start-button">
                <a href={this.props.path} className="btn btn-primary">
                  Continue
                </a>
              </div>
            </div>
          </div>
          <div className="clearfix">&nbsp;</div>
        </div>
      );
    } else if (
      this.props.preTestCompleted &&
      !this.props.postTestPassed &&
      this.props.course_progress == 1
    ) {
      return (
        <div className="progress-section">
          <div className="course-progress">
            <div
              className="progress-bar-chart"
              role="progressbar"
              aria-label={I18n.t("course_name_progress_bar", {
                name: this.props.name,
              })}
              aria-valuemin="0"
              aria-valuemax="100"
              aria-valuenow={this.progressPercentage()}
            >
              <div
                className="progress-amount"
                style={{ width: this.progressPercentage() + "%" }}
              />
            </div>
            <div className="progress-percentage" role="presentation">
              {this.progressPercentage()}% <span>PROGRESS</span>
            </div>
            <div className="test-score">
              <div className="pull-right start-button">
                <a href={this.props.path} className="btn btn-primary">
                  Review
                </a>{" "}
                &nbsp;{" "}
                <a
                  href={this.props.postTestUrl}
                  className="btn btn-primary modal-link hide-modal-footer"
                >
                  Test my knowledge
                </a>
              </div>
            </div>
          </div>
          <div className="clearfix">&nbsp;</div>
        </div>
      );
    } else if (this.props.preTestCompleted && this.props.postTestPassed) {
      return (
        <div className="progress-section">
          <div className="course-progress">
            <div
              className="progress-bar-chart"
              role="progressbar"
              aria-label={I18n.t("course_name_progress_bar", {
                name: this.props.name,
              })}
              aria-valuemin="0"
              aria-valuemax="100"
              aria-valuenow={this.progressPercentage()}
            >
              <div
                className="progress-amount"
                style={{ width: this.progressPercentage() + "%" }}
              />
            </div>
            <div className="progress-percentage" role="presentation">
              {this.progressPercentage()}% <span>PROGRESS</span>
            </div>
            <div className="test-score">
              <div className="pull-right start-button">
                <a href={this.props.path} className="btn btn-primary">
                  Review
                </a>{" "}
                &nbsp;{" "}
                <a
                  href={this.props.postTestUrl}
                  className="btn btn-primary modal-link hide-modal-footer"
                >
                  Passed with {this.props.postTestBestScore}%
                </a>
              </div>
            </div>
          </div>
          <div className="clearfix">&nbsp;</div>
        </div>
      );
    }
  }

  renderQuizScore() {
    var progress_percentage = this.progressPercentage();

    if (this.props.last_quiz_score != null) {
      return (
        <div className="quiz-score">
          {this.props.account &&
          (this.props.account.pre_test_required == "yes" ||
            this.props.account.post_test_required == "yes") ? (
            <div className="score-heading">SCORES</div>
          ) : null}

          {this.props.account &&
          this.props.account.pre_test_required == "yes" ? (
            <div className="quiz-score-text pre-quiz-score">
              <span>PRE</span> {Math.round(this.props.pre_quiz_score * 100)}%
            </div>
          ) : null}

          {this.props.account &&
          this.props.account.post_test_required == "yes" &&
          progress_percentage == 100 &&
          this.props.best_quiz_score ? (
            <div className="quiz-score-text best-quiz-score">
              <span>BEST</span> {Math.round(this.props.best_quiz_score * 100)}%
            </div>
          ) : (
            <div
              style={{ display: "none" }}
              className="quiz-score-text best-quiz-score"
            >
              <span>BEST</span> 0%
            </div>
          )}

          {this.props.account &&
          this.props.account.post_test_required != "yes" ? (
            <div className="quiz-score-text">
              <span style={{ textTransform: "uppercase" }}>
                {I18n.t("last_quiz")}
              </span>{" "}
              {Math.round(this.props.last_quiz_score * 100)}%
            </div>
          ) : null}

          {this.props.account &&
          this.props.account.post_test_required == "yes" &&
          progress_percentage < 100 ? (
            <a
              style={{ visibility: "hidden" }}
              href="#"
              className="btn btn-primary inverted"
            >
              {I18n.t("retake_quiz")}
            </a>
          ) : (
            <a href={this.props.quiz_path} className="btn btn-primary inverted">
              {I18n.t("retake_quiz")}
            </a>
          )}

          <div className="clearfix">&nbsp;</div>
        </div>
      );
    }
  }

  addToMyCourses(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ course_added: true });

    $.ajax({
      type: "POST",
      url: this.props.add_to_my_courses_path,
      data: {
        course_id: this.props.course_id,
        course_collection_id: this.props.course_collection_id,
        course_level_id: this.props.course_level_id,
      },
    }).done(function (data) {
      // Shhh...
    });
  }

  confirmRemoveFromMyCourses(e) {
    e.preventDefault();
    e.stopPropagation();

    var confirmed = confirm(I18n.t("remove_from_my_courses_confirmation"));

    if (confirmed) {
      this.removeFromMyCourses(e);
      this.setState({});
    }
  }

  onGotoCourse(e) {
    if (
      this.props.course_preview == "preview_modal" &&
      !this.state.course_added
    ) {
      e.preventDefault();
      var tracker_id = $("#ga_tracker_id").val();

      if (typeof ga != "undefined" && tracker_id) {
        try {
          ga("create", tracker_id, "auto");
          ga(
            "send",
            "event",
            "Course Collection",
            "previewCourse",
            this.props.course_collection.name,
            { nonInteraction: false }
          );
          ga("send", "event", "Course", "previewCourse", this.props.name, {
            nonInteraction: false,
          });
        } catch (e) {
          // Shhh...
        }
      }

      $(this.modalRef.current)
        .modal({
          show: true,
        })
        .modal("show");
    }
  }

  onGotoLearningPlanCourse(e) {
    if (!this.props.preTestCompleted) {
      e.preventDefault();
      $(e.target)
        .parents(".course-card")
        .find(".start-button a")
        .trigger("click");
    } else if (this.props.preTestCompleted && this.props.course_progress == 0) {
      // do nothing
    } else if (
      this.props.preTestCompleted &&
      !this.props.postTestPassed &&
      this.props.course_progress > 0 &&
      this.props.course_progress < 1
    ) {
      // do nothing
    } else if (
      this.props.preTestCompleted &&
      !this.props.postTestPassed &&
      this.props.course_progress == 1
    ) {
      // do nothing
    } else if (this.props.preTestCompleted && this.props.postTestPassed) {
      // do nothing
    }
  }

  progressPercentage() {
    var percentage = Math.round(this.props.course_progress * 100);

    if (percentage > 100) {
      return 100;
    } else if (percentage < 0) {
      return 0;
    } else {
      return percentage;
    }
  }

  removeFromMyCourses(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ course_added: false });

    $.ajax({
      type: "POST",
      url: this.props.remove_from_my_courses_path,
      data: {
        course_id: this.props.course_id,
      },
    }).done(function (data) {
      // Shhh...
    });
  }

  onKeyDownRemove(e) {
    if (e.keyCode === 13) {
      this.props.onRemove(e);
    }
  }
}
